<template>
  <div class="lampOtherInfo-content" v-loading="loading">
    <div class="table-head">
      <el-button icon="el-icon-refresh-right" type="warning" @click="getTableData()" size="small" round>{{$t('device.refresh')}}</el-button>
    </div>
    <el-table :data="dataInfo" border :cell-style="columnStyle" class="info-table">
      <el-table-column prop="text1" :label="$t('device.attribute')"></el-table-column>
      <el-table-column prop="value1" :label="$t('device.value')"></el-table-column>
      <el-table-column prop="text2" :label="$t('device.attribute')"></el-table-column>
      <el-table-column prop="value2" :label="$t('device.value')"></el-table-column>
    </el-table>
  </div>
</template>
<script>
import lampsApi from "@/api/device/lamps";
export default {
  name: "lampOtherInfo",
  props: {
    id: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      dataInfo: []
    };
  },
  methods: {
    getTableData() {
      const that = this
      that.loading = true;
      lampsApi.lightInfo(this.id).then((res) => {
        that.loading = false;
        if (res.data.code === 1000) {
          if(res.data.data.sensor&&res.data.data.sensor.id){
            const dataInfo = res.data.data.sensor;
            let dataArr = []
            dataArr[0]= {
              text1: this.$t('device.detail_text1'),
              value1: dataInfo.lamp_cap_num,
              text2: this.$t('device.detail_text2'),
              value2: dataInfo.temp
            }
            dataArr[1]= {
              text1: this.$t('device.detail_text3'),
              value1: dataInfo.solar_panel_voltage,
              text2: this.$t('device.detail_text4'),
              value2: dataInfo.battery_voltage
            }
            dataArr[2]= {
              text1: this.$t('device.detail_text5'),
              value1: dataInfo.charging_current,
              text2: this.$t('device.detail_text6'),
              value2: dataInfo.discharge_voltage
            }
            dataArr[3]= {
              text1: this.$t('device.detail_text7'),
              value1: dataInfo.discharge_current,
              text2: this.$t('device.detail_text8'),
              value2: dataInfo.total_charging
            }
            dataArr[4]= {
              text1: this.$t('device.detail_text9'),
              value1: dataInfo.total_discharge,
              text2: this.$t('device.detail_text10'),
              value2: dataInfo.voltage
            }
            dataArr[5]= {
              text1: this.$t('device.detail_text11'),
              value1: dataInfo.current,
              text2: this.$t('device.detail_text12'),
              value2: dataInfo.electricity
            }
            dataArr[6]= {
              text1: this.$t('device.detail_text13'),
              value1: dataInfo.total_electricity,
              text2: this.$t('device.detail_text14'),
              value2: dataInfo.drain_voltage
            }
            dataArr[7]= {
              text1: this.$t('device.detail_text15'),
              value1: dataInfo.drain_current,
              text2: this.$t('device.detail_text16'),
              value2: dataInfo.power
            }
            dataArr[8]= {
              text1: this.$t('device.detail_text17'),
              value1: dataInfo.power_factor,
              text2: this.$t('device.detail_text18'),
              value2: dataInfo.work_time
            }

            that.dataInfo = dataArr
            // console.log('that.dataInfo', that.dataInfo)
          } else {
            that.dataInfo = []
          }
        }else{
          that.dataInfo = []
        }
      })
    },

    columnStyle({ columnIndex }) {
      if (columnIndex === 0||columnIndex === 2) {
        return 'background:#f5f7f9'
      }
    }
  },
  mounted() {
    this.getTableData();
  },
};
</script>
<style lang='less' scoped>
.lampOtherInfo-content {
  width: 100%;
  .table-head{
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-bottom: 20px;
    margin-top: -60px;
  }
}
</style>
<style lang="less">
.info-table{
  width: 100%;
  margin-top:0;
  td, th{
    padding: 15px 0 !important
  }
}
</style>